import React from "react";
import { useSeo } from "@/hooks/useSeo";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    body: [
      "OyeBest ('we', 'us') respects your privacy. This policy explains how we collect, use and protect your information when you use oyebest.in.",
      "We collect information you provide directly — such as your name, mobile number and enquiry details when you contact a business or submit a form. This is used only to connect you with the relevant business and to improve our services.",
      "We do not sell your personal information. We do not expose private customer information publicly. Business owners can only see enquiries submitted to their own business.",
      "We may collect basic analytics (page views, clicks) to understand how the platform is used. Location is requested only when you use 'Near Me' features and is used solely to show nearby results.",
      "For any privacy questions, contact us at oyebest.in@gmail.com.",
    ],
  },
  terms: {
    title: "Terms & Conditions",
    body: [
      "By using OyeBest (oyebest.in) you agree to these terms. OyeBest is a local business discovery platform that helps users find businesses and services in their city.",
      "Business listings may be submitted by owners or added by our team. Listings marked as 'Demo' or 'Sample' are for showcase purposes and do not represent verified real businesses.",
      "We strive for accuracy but do not guarantee that all business information (hours, prices, contact details) is always correct. Please verify directly with the business before visiting.",
      "Verified and Featured badges indicate our verification status or promotional placement. Sponsored/paid placements are clearly labelled where applicable.",
      "Users must not submit fake reviews, misleading information or abusive content. We reserve the right to remove any content that violates these terms.",
    ],
  },
  disclaimer: {
    title: "Disclaimer",
    body: [
      "The information provided on OyeBest is for general informational purposes only. All listings are provided in good faith.",
      "OyeBest is a discovery platform and is not responsible for the products, services, quality or conduct of any listed business. Any transaction or interaction you have with a business is solely between you and that business.",
      "Ratings and reviews reflect the opinions of individual users. OyeBest does not create fake ratings or reviews.",
      "For corrections or to report incorrect information, please contact oyebest.in@gmail.com.",
    ],
  },
};

export default function StaticPage({ page }) {
  const c = CONTENT[page] || CONTENT.privacy;
  useSeo(`${c.title} | OyeBest`, `${c.title} for OyeBest — oyebest.in`);
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
      <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight">{c.title}</h1>
      <div className="mt-6 space-y-4 text-foreground/80 leading-relaxed">
        {c.body.map((p) => <p key={p}>{p}</p>)}
      </div>
    </div>
  );
}
